import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pre-check-in',
  templateUrl: './pre-check-in.component.html',
  styleUrls: ['./pre-check-in.component.scss']
})
export class PreCheckInComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
